import { render, staticRenderFns } from "./DeviceSensorTime.vue?vue&type=template&id=22858315&"
import script from "./DeviceSensorTime.vue?vue&type=script&lang=js&"
export * from "./DeviceSensorTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports